module.exports = __webpack_public_path__ + "img/filipe.166c5e95.png";